export default "__VITE_ASSET__6298266f__"